import { IMyselfState } from 'types/myself';

export default function chooseNewDisplayQualitySuccess(
  state: IMyselfState,
  payload: { data: { id: number } },
  key: 'mantelpieceItemId' | 'scrapbookStatusId',
) {
  const { data: { id } } = payload;
  return {
    ...state,
    character: {
      ...state.character,
      [key]: id,
    },
  };
}